import { useQmsExamRoomCheckExamStatusByBookIdAndExamIdQuery as useCheckExamStatusByBookIdAndExamId } from '../../generated/graphql';

export default useCheckExamStatusByBookIdAndExamId;
